import React, { useMemo } from "react"

interface SubsectionContainerProps {
  gridContainerClassOverride?: string
  spanLastItem?: boolean
}

const BoxComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="border border-solid border-gray-300 rounded-lg h-full flex items-stretch">
      <div className="p-4 w-full h-full">{children}</div>
    </div>
  )
}

const SubsectionContainer: React.FC<
  React.PropsWithChildren<SubsectionContainerProps>
> = ({ children, gridContainerClassOverride = "", spanLastItem = true }) => {
  const childrenArray = useMemo(
    () => React.Children.toArray(children),
    [children],
  )
  const count = childrenArray.length

  const gridTemplate = useMemo(() => {
    return count === 1 ? "grid-cols-1" : "grid-cols-2"
  }, [count])

  const gridContainerClass = useMemo(() => {
    const baseClass = `grid ${gridTemplate} gap-5`
    return gridContainerClassOverride ? gridContainerClassOverride : baseClass
  }, [gridContainerClassOverride, gridTemplate])

  return (
    <div className={gridContainerClass}>
      {childrenArray.map((child, index) => (
        <div
          key={index}
          className={`${spanLastItem && count % 2 !== 0 && index === count - 1 ? "col-span-2" : ""}`}
        >
          <BoxComponent>{child}</BoxComponent>
        </div>
      ))}
    </div>
  )
}

export default SubsectionContainer
